var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-heading',[_c('portal',{attrs:{"to":"title"}},[_c('img',{attrs:{"src":require("../assets/images/icon-QR.svg"),"alt":""}}),_c('span',[_vm._v("Materials")])]),_c('BookContentExtended',{staticClass:"materials-page",attrs:{"address":"0xaEEeBd6ca46BEf69689F043681fEe5F9961D199A","network":"goerli","folder":"Materials","blocks":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }